import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class RapoarteService {
    private basePath = environment.interop.basePath;
    private generateUrl = this.basePath + environment.interop.indoc.rapoarte.generate;

    constructor(private http: HttpClient) { }

    generateReport(documentIds: number[]): Observable<Blob> {
        const payload = {
            documentIds: documentIds
        };

        return this.http.post(this.generateUrl, payload, {
            responseType: 'blob'
        });
    }
}
